module.exports = __webpack_public_path__ + "static/media/violin.437d7c61.svg";